<template lang="html">
  <transition :name="type">
    <div class="flex flex-wrap h-screen w-screen top-0 absolute">
    <aside
      class=""
      :class="type"
    >
      <!-- <div
        v-if="type === 'tray'"
        :class="applyWarningColors ? 'overlay-primary' : 'overlay-dark'"
        @click.stop="close"
      /> -->
      <div
        class="light-background"
        :class="[
          align,
          applyWarningColors ? 'card-with-primary-background' : 'card-with-dark-background'
        ]"
        @mouseover="hoversHere = true"
        @mousemove="$emit('update:hovering', true)"
        @mouseleave="onMouseLeave"
        @click.stop=""
        v-finger:swipe="this.onSwipe"
      >
        <!-- <button
          aria-label="Close"
          class="button icon-only-dark close"
          v-if="withCloseButton"
          @click.stop="close"
    			v-on:touchstart=""
          ref="closeButton"
        /> -->
        <div class="content flex-1 mx-6 h-screen absolute">
          <slot />
        </div>
      </div>
      <KeyboardShortcuts
        @onTabPress.once="onTab"
        @onEscapePress="close" />
    </aside>
    </div>
  </transition>
</template>

<script>
import KeyboardShortcuts from './KeyboardShortcuts'

export default {

  name: 'Modal',

  components: {
    KeyboardShortcuts
  },

  props: {
    title: { // Just used for event tracking stats
      required: true,
      type: String
    },
    type: {
      required: true,
      type: String,
      validator: function (value) {
        return ['tray', 'notification'].indexOf(value) !== -1
      }
    },
    alignment: { // Defines where on the screen the card has to be placed
      required: false,
      type: String,
      validator: function (value) {
        return [undefined, '', 'top', 'bottom'].indexOf(value) !== -1
      }
    },
    withCloseButton: {
      required: false,
      type: Boolean
    },
    autoCloseInterval:{ // Number of seconds the modal should stay visible.
      required: false,
      type: Number
    },
    applyWarningColors: {
      required: true,
      type: Boolean
    },
    listenToGestures: {
      required: false,
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      align: this.alignment,
      hoversHere: false, // Is the mouse hovering over the card area?
    }
  },

  mounted(){
    this.setStyle()
    this.autoClose()
  },

  destroyed(){
    this.$emit('update:hovering', false)
    this.$emit('closing')
  },

	methods: {

    onSwipe(e){
      if (
        (this.type === "notification" && e.direction === "Up" && this.alignment === 'top') ||
        (this.type === "notification" && e.direction === "Down" && this.alignment === 'bottom') ||
        (this.type === "tray" && e.direction === "Right")
      ){
        this.close()
      }
    },

    setStyle(){
      if (this.align == ''){
        this.align = "top"
      }
    },

    onMouseLeave(){
      this.hoversHere = false
      this.$emit('update:hovering', false)
    },

    autoClose(){
      if (this.autoCloseInterval){
        setTimeout(() => {
          if (this.hoversHere) this.autoClose()
          else this.$emit('autoClose')
    		}, this.autoCloseInterval * 1000)
      }
    },

    // Set focus to close button
    onTab(e){
      e.preventDefault()
      this.$refs.closeButton.focus()
    },

		close(){
			this.$emit('close')
		}
	}
}
</script>

<style scoped lang="scss">

@import '../style/abstracts/variables.scss';
@import '../style/abstracts/functions.scss';
@import '../style/abstracts/mixins.scss';


// Container
////////////

.modal{
  // position: relative;
  // top: 0;
  // right:0;
  // left:0;
  // display: flex;
  // height: 100vh;
  // height: calc(var(--vh, 1vh) * 100);
  // justify-content: center;

  // Following 2 lines are for smooth scrolling on iOS, https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-overflow-scrolling:
  // overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.notification{
  pointer-events: none; // Allow clicks on elements underneath this container.

  .card{
    pointer-events: auto;
  }
}

// Transparent background
/////////////////////////

// Only shown behind trays.
.overlay-primary,
.overlay-dark{
  display: flex;
  justify-content: center;
}
.overlay-primary{
  background-color: $color-overlay-primary;
}
.overlay-dark{
  background-color: $color-overlay-dark;
}


// Cards for notifications and tray
///////////////////////////////////

$padding-x-1: $large;
$padding-x-2: 1.5*$large;

.card{
  position: absolute;
  width: auto;
  max-width: 90%;
  padding-top: $medium+rem;
  padding-left: $padding-x-1 + rem;
  padding-bottom: $medium + rem;
  padding-right: $padding-x-1 + rem;
  transition: padding linear $duration-short+ms;

  &.top {
    top: $default+rem;
    margin-top: env(safe-area-inset-top);
  }
  &.bottom {
    bottom: $default+rem;
    margin-bottom: env(safe-area-inset-bottom);
  }

  @media (min-width: 490px){
    padding-top: $medium+$small+rem;
    padding-left: $padding-x-2+rem;
    padding-bottom: $medium+$small+rem;
    padding-right: $padding-x-2+rem;
  }
  @media (min-width: 700px){
    max-width: 0.95*700+px;
  }
}

$tray-max-width: 11*$large;

.tray{

  .card{
    position: absolute;
    top: 0;
    right: 0;
    width: calc(100vw - #{$default+rem});
    max-width: $tray-max-width+rem;
    min-height: 100vh;
    min-height: calc(var(--vh, 1vh) * 100);
    padding-left: $medium + rem;
    padding-right: $medium + rem;
    padding-bottom: $large + rem;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    z-index: 1; // Bug fix for Firefox, which doesn't scrolling inside the tray otherwise.

    @media (min-width: 490px){
      padding-left: $padding-x-2 + rem;
      padding-right: $padding-x-2 + rem;
    }

    .content{
      padding-top: env(safe-area-inset-top); // iPhone X safe area
      padding-bottom: env(safe-area-inset-bottom); // iPhone X safe area
    }
  }
  .card-with-dark-background{
    box-shadow: 0 0.8rem 7rem $color-drop-shadow-dark;
  }
  .card-with-primary-background{
    box-shadow: 0 0.8rem 7rem $color-drop-shadow-primary;
  }
}

// Close button
///////////////

.button.close{
  position: absolute;
  top: ($large - $button-size-small-screen)/2 +rem; // Align with single line content
  left: 0;
  background-image: url('../assets/images/Icon/Close/Dark.svg');

  @media (min-height: $break-xs){
    top: 0; // Align with single line content, when button sizes are increased
  }

  .notification &{
    @media (min-width: 490px){
      top: $small+rem;
      left: $small+rem;
    }
  }
  .tray &{
    top: env(safe-area-inset-top); // iPhone X safe area
  }
}
.with-motion{

  // Transitions for notifications
  ////////////////////////////////

  // Enter
  .notification-enter-active{
    transition: line-height $duration-medium+ms; // Main element needs transition, otherwise children aren't transitioned.

    .card{

      &.top{
        animation: bounce-in-top $duration-medium+ms;
      }
      &.bottom{
        animation: bounce-in-bottom $duration-medium+ms;
      }
    }
  }
  // Leave
  .notification-leave-active{
    transition: line-height $duration-medium+ms;

    .card{
      transition: transform $duration-medium+ms $ease-in-quart;
    }
  }
  .notification-leave{

    .card{
      transform: translateY(0rem);
      transform: translateX(0rem);
    }
  }
  .notification-leave-to{

    .top{
      transform: translateY(-100rem);
    }
    .bottom{
      transform: translateY(100rem);
    }
  }
  // Transitions for trays
  ////////////////////////////////


  // Enter

  .tray-enter-active{
    transition: line-height $duration-very-long+ms; // Main element needs transition, otherwise children aren't transitioned.

    .overlay-primary,
    .overlay-dark{
      transition: opacity $duration-very-long+ms $ease-out-expo;
    }
    .card{
      transition: transform $duration-medium+ms $ease-out-expo ;
    }
  }
  .tray-enter{

    &.tray{

      .overlay-primary,
      .overlay-dark{
        opacity: 0;
      }
      .card{
        transform: translateX(100%);

        @media screen and (max-width:  $tray-max-width + rem){
          transform: translateX(1* $tray-max-width + rem);
        }
      }
    }
  }
  .tray-enter-to{

    .card{
      transform: translateX(0);
    }
  }

  // Leave

  .tray-leave-active{
    transition: line-height $duration-medium+ms; // Main element needs transition, otherwise children aren't transitioned.

    .overlay-primary,
    .overlay-dark{
      transition: opacity $duration-medium+ms $ease-in-expo;
    }
    .card{
      transition: transform $duration-medium+ms ease-in;
    }
  }
  .tray-leave{

    .overlay-primary,
    .overlay-dark{
      opacity: 1;
    }
    .card{
      transform: translateX(0rem);
    }
  }
  .tray-leave-to{

    .overlay-primary,
    .overlay-dark{
      opacity: 0;
    }
    .card{
      transform: translateX(100%);

      @media screen and (max-width:  $tray-max-width + rem){
        transform: translateX(1* $tray-max-width + rem);
      }
    }
  }
}

// Animation
////////////

@keyframes bounce-in-top {
  0%{
    transform: translateY(-20rem);
  }
  60%{
    transform: translateY(2.5rem);
  }
  94%{
    transform: translateY(-0.3rem);
  }
  100%{
    transform: translateY(0);
  }
}
@keyframes bounce-in-bottom {
  0%{
    transform: translateY(20rem);
  }
  60%{
    transform: translateY(-2.5rem);
  }
  94%{
    transform: translateY(0.3rem);
  }
  100%{
    transform: translateY(0);
  }
}
@keyframes bounce-in-left {
  0%{
    transform: translateX(-100%);
  }
  70%{
    transform: translateX(4%);
  }
  90%{
    transform: translateX(-1%);
  }
  100%{
    transform: translateX(0);
  }
}
@keyframes bounce-in-left-wide {
  0%{
    transform: translateX(-1*$tray-max-width+rem);
  }
  60%{
    transform: translateX(1.25rem);
  }
  94%{
    transform: translateX(-0.15rem);
  }
  100%{
    transform: translateX(0);
  }
}
</style>

<style lang="scss">
@import '../style/abstracts/variables.scss';
@import '../style/abstracts/functions.scss';
@import '../style/abstracts/mixins.scss';

.modal {

  .card{

    h1{
      margin-top: $large+rem
    }
  }
}
.modal not(.tray){

  .card{

    p{
      &:last-child{
        margin-bottom: 0;
      }
    }
  }
}
.card>p:last-child,
.card .content>p:last-child{
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue